module.exports = __webpack_public_path__ + "static/media/21ECLAC36.1852f9bc.jpg";